import { FunctionComponent, useEffect } from 'react';
import { useCurrentRecording } from 'features/recordings/recordingHooks';
import { useSelector } from 'react-redux';
import { RootState } from 'rootReducer';
import { useAudioPosition } from 'features/audio/useAudioPosition';
import { RecordingListenEventPayload, sendEvent } from 'api/v3/send_event';

export const SendRecordingListenEvents: FunctionComponent = () => {
  const recording = useCurrentRecording();
  const playing = useSelector((state: RootState) => state.audio.playing);
  const { duration, position } = useAudioPosition();

  const minute = Math.ceil(position / 60);

  useEffect(() => {
    if (minute && recording && playing) {
      console.debug(
        'Minute:',
        minute,
        'Playing:',
        playing,
        'Recording:',
        recording,
        'Duration:',
        duration
      );

      const payload: RecordingListenEventPayload = {
        type: 'recordings::listen_event_type',
        recording_id: recording.id,
        owner_id: recording.userId,
        minute: minute,
        recording_duration_minutes: duration,
        recording_title: recording.title
      };

      (async () => await sendEvent(payload))();
    }
  }, [recording, duration, minute, playing]);

  return null;
};
